/**
 * Product gallery — carousel, thumbs, variant sync, fullscreen lightbox + zoom.
 */
(function () {
  function initGallery(root) {
    const track = root.querySelector('[data-gallery-track]');
    const slides = [...root.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const prevBtn = root.querySelector('[data-gallery-prev]');
    const nextBtn = root.querySelector('[data-gallery-next]');
    const lightbox = root.querySelector('[data-gallery-lightbox]');
    const lightboxImg = lightbox?.querySelector('[data-lightbox-img]');
    const lightboxStage = lightbox?.querySelector('[data-lightbox-stage]');
    const variantSelect = document.getElementById('ProductSelect');
    if (!track || slides.length === 0) return;

    let index = slides.findIndex((s) => s.classList.contains('is-active'));
    if (index < 0) index = 0;
    let zoomed = false;

    function setSlide(i) {
      index = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach((slide, idx) => {
        slide.classList.toggle('is-active', idx === index);
        slide.hidden = idx !== index;
      });
      thumbs.forEach((thumb, idx) => {
        thumb.classList.toggle('is-active', idx === index);
        thumb.setAttribute('aria-current', idx === index ? 'true' : 'false');
      });
      if (lightbox?.open) syncLightbox();
    }

    function syncLightbox() {
      if (!lightboxImg) return;
      const slide = slides[index];
      const src = slide?.dataset?.fullSrc;
      if (!src) return;
      lightboxImg.src = src;
      lightboxImg.alt = slide.dataset.alt || '';
      setZoom(false);
    }

    function setZoom(on) {
      zoomed = on;
      lightboxImg?.classList.toggle('is-zoomed', on);
      if (lightboxStage) lightboxStage.scrollTop = 0;
      if (lightboxStage) lightboxStage.scrollLeft = 0;
    }

    function openLightbox() {
      if (!lightbox || !slides[index]?.dataset?.fullSrc) return;
      syncLightbox();
      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      } else {
        lightbox.setAttribute('open', '');
      }
    }

    function closeLightbox() {
      setZoom(false);
      if (!lightbox) return;
      if (typeof lightbox.close === 'function') lightbox.close();
      else lightbox.removeAttribute('open');
    }

    thumbs.forEach((thumb, idx) => {
      thumb.addEventListener('click', () => setSlide(idx));
    });

    prevBtn?.addEventListener('click', () => setSlide(index - 1));
    nextBtn?.addEventListener('click', () => setSlide(index + 1));

    slides.forEach((slide, idx) => {
      slide.addEventListener('click', () => {
        setSlide(idx);
        openLightbox();
      });
    });

    root.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
    root.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => setSlide(index - 1));
    root.querySelector('[data-lightbox-next]')?.addEventListener('click', () => setSlide(index + 1));

    lightboxImg?.addEventListener('click', () => setZoom(!zoomed));

    lightbox?.addEventListener('click', (e) => {
      if (e.target === lightbox) closeLightbox();
    });

    root.addEventListener('keydown', (e) => {
      if (lightbox?.open) {
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') setSlide(index - 1);
        if (e.key === 'ArrowRight') setSlide(index + 1);
        return;
      }
      if (e.key === 'ArrowLeft') setSlide(index - 1);
      if (e.key === 'ArrowRight') setSlide(index + 1);
    });

    let touchStartX = 0;
    track.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );
    track.addEventListener(
      'touchend',
      (e) => {
        const delta = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(delta) > 40) setSlide(index + (delta < 0 ? 1 : -1));
      },
      { passive: true }
    );

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        const mediaId = option?.dataset?.featuredMedia;
        if (!mediaId) return;
        const target = slides.findIndex((s) => s.dataset.mediaId === mediaId);
        if (target >= 0) setSlide(target);
      });
    }

    setSlide(index);
  }

  function boot() {
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
